import { Link } from "react-router-dom";
import React from "react";
import "./style.css";
export const Subject = ({ title, link, shortcut, onClick }) => {
  return (
    <li className="subject-list-item">
      <Link to={link} className="link" onClick={onClick && onClick}>
        <div className="icon">{shortcut}</div>
        {title}
      </Link>
    </li>
  );
};
